import { colors } from '../foundation';

type Props = {
  color?: (typeof colors.black)[100] | (typeof colors.white)[100];
  size?: number;
};

const AirplaneTakeOff = ({ color = colors.black[100], size = 40 }: Props) => {
  return (
    <svg width={size} height={size} viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="Vehicles &#38; Transport/roaming">
        <path
          id="Vector"
          d="M17.1865 15.4167L10.1865 17.8959L6.75938 15.9563C6.33161 15.7497 5.83936 15.7212 5.39062 15.8771L4.14062 16.4042L6.84896 19.7375C8.84271 22.125 11.7948 23.7104 14.7323 22.6875L31.1135 16.9229C34.7656 15.4479 35.4156 13.7084 35.8656 11.9479C34.4073 10.8521 32.7573 9.53127 29.1448 10.85L22.9969 13.1667M19.1865 16.9938L12.1656 9.86255L14.1219 9.1813C14.3844 9.09011 14.6624 9.05235 14.9397 9.07024C15.217 9.08813 15.4879 9.16131 15.7365 9.28546L25.8115 14.6709M5.81148 30.8084H34.2177"
          stroke={color}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
export default AirplaneTakeOff;
